/* eslint-disable react/no-children-prop */
interface Props {
  actions?: JSX.Element;
  active?: boolean;
  children?: JSX.Element | string | undefined;
  id: string;
  size?: 'small' | 'medium' | 'large';
  slot?: 'secondary-aside';
  stackedAside?: JSX.Element;
  subtitle?: string;
  title?: string;
}
/*
 -- Opening & Closing --
 Aside elements have been extended to include .open() and .close() functions, you should use these functions when opening and closing (see types.tsx).
 The active prop should only be used to dictate the aside's initial position. Set active=true if you would like the aside to be open upon load.
 Buttons have been optimized to include these open/close functions.
 To create an open/close aside button, set the handleClick prop to either 'openAside' or 'closeAside' and be sure that the AsideId is set to the same id as the Aside in question.
 When the it become necessary to open or close an Aside without the use of a button, copy the function defined in Button.tsx into your own component.

 -- Stacking Asides --
 When stacking asides, pass the secondary aside through the stackedAside prop as another <Aside> component.
 Make sure the slot prop of the stackedAside is set to 'secondary-aside" or this will not render correctly.

 -- Best Practices --
 When rendering an aside based on variable data such as 'making a resident key', only render one aside and use State to change data and functionality.
 EX: Do not render separate asides for each possible resident that you may want to make a key for
*/

const Aside = ({
  actions,
  active = false,
  children,
  id,
  size = 'medium',
  slot,
  stackedAside,
  subtitle,
  title,
}: Props) => {
  return (
    <raul-aside
      // @ts-expect-error: children "does not exist on type"
      children={
        <>
          {(title || subtitle) && (
            <raul-aside-header>
              {/* @ts-expect-error: children "does not exist on type" */}
              {title && <raul-aside-title children={title} />}
              {/* @ts-expect-error: children "does not exist on type" */}
              {subtitle && <raul-aside-subtitle children={subtitle} />}
            </raul-aside-header>
          )}
          {/* @ts-expect-error: children "does not exist on type" */}
          <raul-aside-body children={children} />

          {actions && (
            <raul-aside-footer>
              {/* @ts-expect-error: children "does not exist on type" */}
              <raul-aside-actions children={actions} />
            </raul-aside-footer>
          )}
          {stackedAside}
        </>
      }
      active={active}
      id={`${id}-aside`}
      size={size}
      slot={slot}
    />
  );
};

export default Aside;
